//C:\Users\Anish\xpr_survey\XPRSuvey-App\src\Components\Survey\Services\MasterDataService.js
import api from "../../axios";

export const getChannels = () => {
  return api.get("/api/XPRS_Survey/XPRSSurveyMasterData/Channel");
};

export const GetRoles = () => {
  return api.post("/api/XPRS_Survey/XPRSSurveyMasterData/GetRoles");
  // return response.data;
};

export const createChannel = (channelName, channelCode) => {
  return api.post("/api/XPRS_Survey/XPRSSurveyMasterData/Channel", {Channel: channelName});
};


export const updateChannel = (channelId, channelName, isActive) => {
  return api.post("/api/XPRS_Survey/XPRSSurveyMasterData/Channel", {
    channelId: channelId,
    channel: channelName,
     isActive: Boolean(isActive), // 1 = Active, 0 = Inactive
  });
};

export const AddCompany = (payload) => {
  return api.post("/api/XPRS_Survey/XPRSSurveyMasterData/AddCompany", payload);
};

export const CompanyDropdown = (payload) => {
  return api.post("/api/XPRS_Survey/XPRSSurveyMasterData/CompanyDropdown", payload);
};

// GET — fetches the list of mail templates (Reminder / Invitation / Completion / etc.)
export const GetMasterTemplateData = () => api.get("/api/XPRS_Survey/XPRSSurveyMasterData/GetMasterTemplateData");

